/* eslint-disable */
import '@dw/js-sdk';
import { m_getUrlKey } from '@/common/utils'

window.dw.setAppKey('b9abcee31dd6ee28'); // 必须调用此方法，传入你产品的唯一标识
window.dw.setDebug(
  process.env.NODE_ENV_PACK_ENV === 'test' || process.env.NODE_ENV === 'development'
); // 在调试时开启为true,线上环境请务必开启为false

/**
 *
 * @param {*} event 事件类型（点击、页面展示等）
 * @param {*} pageType 页面类型 PC/mobile
 * @param  {...any} args 事件参数
 */
export function dwCollectData(event, name, type, args) {
  const obj = { type, name};
  Object.assign(obj, args);
  dwOnEvent(event, obj);
}

/*
处理页面跳转前上报事件丢失,提前设置好页面跳转时要上报的事件
https://npm.wps.cn/package/@dw/js-sdk
setAppEndExtraData方法
*/
export function setAppEndExtraData(event, name, type, args) {
  const obj = { type, name };
  Object.assign(obj, args);
  
  if (process.env.NODE_ENV_PACK_ENV !== 'prod') {
    console.log(`[埋点][${event}]`, obj);
  }
  window.dw.setAppEndExtraData(event, obj);
}

function dwOnEvent(event, obj) {
  window.dw.setChannel(m_getUrlKey("chn") || 'web');
  if (process.env.NODE_ENV_PACK_ENV !== 'prod') {
    console.log(`[埋点][${event}]`, obj);
  }
  window.dw.onEvent(event, obj);
}
// 提供公共方法，供表单使用
window.dwOnEvent = dwOnEvent;

function setDwCustomPublicAttrs(key, value) {
  window.dw.setCustomPublicAttrs(key, value);
}

export default {
  dwCollectData,
  setAppEndExtraData,
  setDwCustomPublicAttrs
};
